<template>
  <div class="popup-overlay" @click.self="closePopup">
    <div class="popup-modal">
      <div class="popup-body">
        <p class="popup-question">Do you want to have transformation factory along with XSLT?</p>
        <div class="button-group">
          <button type="button" class="btn btn-primary" @click="selectOption('yes')">
            Yes
          </button>
          <button type="button" class="btn btn-secondary" @click="selectOption('no')">
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransformationFactoryPopup',
  emits: ['close', 'confirm'],
  methods: {
    closePopup() {
      this.$emit('close');
    },
    selectOption(choice) {
      this.$emit('confirm', choice);
    }
  }
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.popup-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 400px;
  max-width: 500px;
  position: relative;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #dee2e6;
}

.popup-title {
  margin: 0;
  font-weight: 600;
  color: #333;
}

.btn-close {
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.btn-close:hover {
  color: #333;
}

.popup-body {
  padding: 1.5rem;
  text-align: center;
}

.popup-question {
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
  color: #555;
}

.button-group {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn {
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.btn-primary {
  background-color: #da6a26;
  color: white;
}

.btn-primary:hover {
  background-color: #c55a1f;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #5a6268;
}
</style>
